import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import DebouncedInput from "../../../components/DebouncedInput"
import { centerStatusOptions } from "../statusConfig"
import StatusHint from "./StatusHint"

export const ALL = "ALL"

const SEGMENTS = [
  { value: ALL, label: "All" },
  ...centerStatusOptions.map(({ value, label, describe }) => ({
    value,
    label: value === "CEO_DUE" ? "CEO Call Due" : label,
    describe,
  })),
]

const CenterToolbar = ({
  centerName,
  setCenterName,
  status,
  setStatus,
  studyLimit,
}) => (
  <div className="mb-3 flex flex-wrap items-center gap-3 rounded-lg bg-gray-50 p-2">
    <div
      aria-label="Filter centers by status"
      className="inline-flex rounded-lg bg-gray-100 p-1"
      role="group"
    >
      {SEGMENTS.map((seg) => (
        <StatusHint
          key={seg.value}
          placement="bottom"
          text={seg.describe?.({ studyLimit })}
        >
          <button
            aria-pressed={status === seg.value}
            className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-semibold transition-colors ${
              status === seg.value
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
            type="button"
            onClick={() => setStatus(seg.value)}
          >
            {seg.label}
          </button>
        </StatusHint>
      ))}
    </div>

    <div className="relative ml-auto">
      <FontAwesomeIcon
        className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400"
        icon={faMagnifyingGlass}
      />
      <DebouncedInput
        className="w-56 rounded-lg border border-gray-300 py-2 pl-9 pr-3 text-sm focus:border-secondary_dark focus:outline-none focus:ring-1 focus:ring-secondary_dark"
        placeholder="Find a center"
        type="text"
        value={centerName}
        onChange={(value) => setCenterName(value.trim())}
      />
    </div>
  </div>
)

export default CenterToolbar
